import { render, staticRenderFns } from "./ItemCopyInterface.vue?vue&type=template&id=c966ac98&"
import script from "./ItemCopyInterface.vue?vue&type=script&lang=js&"
export * from "./ItemCopyInterface.vue?vue&type=script&lang=js&"
import style0 from "./ItemCopyInterface.vue?vue&type=style&index=0&id=c966ac98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VRadio,VRadioGroup})
